export const closeMessage = () => {
    return { type: 'CLOSE_FLOATING_ALERT' }
}
